module.exports = "#bg {\n    position: fixed; \n    top: 0; \n    left: 0; \n      min-width: 100%;\n    min-height: 100%;\n  }\n  \n      \n  .boton{\n    width:100%;\n    margin-top:10px;\n  }\n  \n      \n  .input-group{\n    margin-top: 10px;\n  }\n  \n      \n  .alert{\n    margin-top:10px;\n  }\n  \n      \n  p{\n    margin-top: 10px;\n  }\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/autenticacion/recuperarcont/recuperarcont.component.css
// module id = ./src/app/autenticacion/recuperarcont/recuperarcont.component.css
// module chunks = main